import { EnumSchema } from '../metadata-schema';

export const IndicatorNaam: EnumSchema = {
	"type": "string",
	"title": "IndicatorNaam",
	"enum": [
		"bovenbouwsucces",
		"cijferverschil",
		"examencijfers",
		"onderbouwsnelheid",
		"onderwijspositie"
	]
};
